import { error, finish } from '../../../modules/markets/actions/add-all-selections';
import api from '../../../api';
import { toJS } from 'mobx';

export async function request(dispatch, { eventId, marketId, participants }) {
    for (const participant of participants) {
        const name = toJS(participant).name;

        const requestBody = {
            data: {
                name,
                display: false,
                active: false
            }
        };
        const result = await $appState.sdkStaff.createSelection({
            event_id: eventId,
            market_id: marketId,
            selection_id: 'custom',
            requestBody
        });
        
        if (result.status === 'error') {
            const error = new Error(`Error creating selection ${name}`);
            
            return dispatch(error(marketId, error));
        }
    }

    const market = await $appState.sdkStaff.socket_get_market(marketId);

    const selections = market.selections;

    const addedSelections = Object.keys(selections)
        .slice(Object.keys(selections).length - participants.length)
        .map((key) => selections[key]);

    return dispatch(finish(marketId, addedSelections));
}
